import * as React from 'react';

import { CommonContainer } from '../../styled';

import { Wrapper } from './styled';

export const RichContentContainer: React.FC<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rcComponent: any;
  name: string;
}> = ({ rcComponent }) => {
  if (!rcComponent) {
    return null;
  }

  return (
    <CommonContainer id="pdRichContent">
      <Wrapper>{rcComponent}</Wrapper>
    </CommonContainer>
  );
};
